var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0199 5.31246C12.2152 5.50772 12.2152 5.82431 12.0199 6.01957L7.35323 10.6862C7.15797 10.8815 6.84138 10.8815 6.64612 10.6862L3.97945 8.01957C3.78419 7.82431 3.78419 7.50772 3.97945 7.31246C4.17472 7.1172 4.4913 7.1172 4.68656 7.31246L6.99967 9.62558L11.3128 5.31246C11.5081 5.1172 11.8246 5.1172 12.0199 5.31246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ce3f80e39ff6e5569d3c8f5b12c7395a.svg";
export { ForwardRef as ReactComponent };